import { isServerSide } from "@/lib/is-server-side"

export function isClientSide() {
  return !isServerSide()
}
